import React, { useCallback, useEffect, useState } from 'react';

import { useCoProductions } from 'v2/hooks/products/useCoProductions';

import ProductTable from '../ProductTable';
import QuickView from './components/Quickview';

interface CoProductionsProps {
  search: string;
}

const CoProductions: React.FC<CoProductionsProps> = ({ search }) => {
  const [activeQuickView, setActiveQuickView] = useState(false);
  const [dataProduct, setDataProduct] = useState<any>(null);
  const [paginationParams, setPaginationParams] = useState({ current_page: 1, per_page: 10 });

  const { data, pagination, isFetching } = useCoProductions(paginationParams, search);

  useEffect(() => {
    setPaginationParams(prev => ({ ...prev, current_page: 1 }));
  }, [search]);

  const onChangeRowsPerPage = useCallback((perPage: number) => {
    setPaginationParams(prev => ({ ...prev, current_page: 1, per_page: perPage }));
  }, []);

  const onChangePage = useCallback((page: number) => {
    setPaginationParams(prev => ({ ...prev, current_page: page }));
  }, []);

  const onClickOptions = useCallback((product: any) => {
    setActiveQuickView(true);
    setDataProduct(product);
  }, []);

  return (
    <>
      <ProductTable
        products={data}
        order=''
        onClickOptions={onClickOptions}
        coproduction={true}
        isLoading={isFetching}
        pagination={{
          current_page: pagination?.current_page ?? 1,
          per_page: pagination?.per_page ?? 10,
          total: pagination?.total_items,
          optionsPerPage: '10,20,30,40',
          onChangePage,
          onChangePerPage: onChangeRowsPerPage
        }}
      />

      <QuickView
        active={activeQuickView}
        changeActive={() => setActiveQuickView(prev => !prev)}
        productData={dataProduct}
      />
    </>
  );
};

export default CoProductions;
